module.exports = __webpack_public_path__ + "static/media/line.006dff47.svg";